module.exports = __webpack_public_path__ + "static/img/f9248dde4313e8e6193dcbb05509afcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv7.png
// module id = GZJu
// module chunks = 1